const ZONES = [
  {
    domain: "E-Banking & E-Commerce",
    owner: "CBS-generated IT source",
    badge: "bg-cyan-500/20 text-cyan-300 border-cyan-500/40",
    acc: "text-cyan-300",
    rule: "Row-alignment adapter maps IT source rows to master rows. CBS data owns these fields — no other source writes to these rows.",
    conflict: "If a department source attempts to write to an IT-owned zone, it is either flagged or routed to review.",
  },
  {
    domain: "CARD Returns",
    owner: "CARD Department",
    badge: "bg-violet-500/20 text-violet-300 border-violet-500/40",
    acc: "text-violet-300",
    rule: "CARD source is the sole authority for card-related Title Code rows. IT mirror data for these rows is ignored — CARD values take precedence without triggering a conflict.",
    conflict: "IT source values for CARD-owned rows are suppressed — not routed to review, silently skipped.",
  },
  {
    domain: "BACH Clearing",
    owner: "BACH Department",
    badge: "bg-emerald-500/20 text-emerald-300 border-emerald-500/40",
    acc: "text-emerald-300",
    rule: "BACH source owns its Title Code zone. Same authority model as CARD — dedicated source, no competition from IT mirror.",
    conflict: "Non-BACH sources cannot overwrite BACH-owned rows.",
  },
  {
    domain: "Agent Banking",
    owner: "Agent Banking Department",
    badge: "bg-sky-500/20 text-sky-300 border-sky-500/40",
    acc: "text-sky-300",
    rule: "Agent Banking owns its designated master zone. Because IT may also report agent-adjacent data, authority zones prevent unnecessary conflicts by designating Agent Banking as the primary source.",
    conflict: "Overlapping IT data for Agent Banking rows is suppressed in favour of the authoritative departmental source.",
  },
  {
    domain: "Mobile Banking — APP",
    owner: "Bangla Pay APP source",
    badge: "bg-teal-500/20 text-teal-300 border-teal-500/40",
    acc: "text-teal-300",
    rule: "APP section rows are owned exclusively by the APP source. Written directly from APP adapter output.",
    conflict: "WEB source cannot write to APP rows. Combined APP+WEB rows are calculated separately.",
  },
  {
    domain: "Mobile Banking — WEB",
    owner: "Bangla Pay WEB source",
    badge: "bg-teal-500/20 text-teal-300 border-teal-500/40",
    acc: "text-teal-300",
    rule: "WEB section rows are owned exclusively by the WEB source.",
    conflict: "APP source cannot write to WEB rows.",
  },
  {
    domain: "Mobile Banking — APP+WEB",
    owner: "Platform calculation engine",
    badge: "bg-purple-500/20 text-purple-300 border-purple-500/40",
    acc: "text-purple-300",
    rule: "Combined APP+WEB rows are not written from any source directly — they are calculated by the platform from the APP and WEB values after both individual sources are processed.",
    conflict: "No source can write directly to combined rows — calculation is platform-owned.",
  },
  {
    domain: "Remittance",
    owner: "Remittance source (structured or legacy)",
    badge: "bg-amber-500/20 text-amber-300 border-amber-500/40",
    acc: "text-amber-300",
    rule: "Remittance zone is owned by the Remittance adapter regardless of whether the structured workbook or the legacy text source is used.",
    conflict: "No other source competes for Remittance rows.",
  },
];

export default function AuthorityModel() {
  return (
    <div className="space-y-4">
      <div>
        <p className="font-mono text-[10px] tracking-[0.25em] text-slate-500">AUTHORITY MODEL</p>
        <h4 className="mt-1 text-sm font-semibold text-white">Source authority zones</h4>
        <p className="mt-1 text-xs text-slate-400">
          Every reporting domain in the master workbook is assigned exactly one authoritative source. When a non-owning source attempts to write to a zone it doesn't own, the platform suppresses or routes it — preventing accidental overwrites without human intervention.
        </p>
      </div>

      {/* Principle callout */}
      <div className="rounded-xl border border-emerald-500/20 bg-emerald-500/5 p-3">
        <p className="font-mono text-[10px] tracking-[0.2em] text-emerald-400">DESIGN PRINCIPLE</p>
        <p className="mt-1 text-xs text-slate-300">
          A single authoritative source per reporting zone eliminates the root cause of accidental overwrites: ambiguity about which source should "win." Zones make that decision structural rather than conditional.
        </p>
      </div>

      {/* Zone table */}
      <div className="space-y-2">
        {ZONES.map((z) => (
          <div key={z.domain} className="rounded-xl border border-white/10 bg-white/5 p-3">
            <div className="mb-2 flex flex-wrap items-center gap-2">
              <span className={`rounded border px-2 py-0.5 font-mono text-[9px] font-bold ${z.badge}`}>{z.domain}</span>
              <span className={`text-[10px] ${z.acc}`}>→ {z.owner}</span>
            </div>
            <p className="text-[11px] leading-relaxed text-slate-400">{z.rule}</p>
            <p className="mt-1.5 rounded bg-black/20 px-2 py-1 font-mono text-[9px] text-slate-500">{z.conflict}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
